import { render, staticRenderFns } from "./relatorioFixo.vue?vue&type=template&id=793bd4cf&scoped=true"
import script from "./relatorioFixo.vue?vue&type=script&lang=js"
export * from "./relatorioFixo.vue?vue&type=script&lang=js"
import style0 from "./relatorioFixo.vue?vue&type=style&index=0&id=793bd4cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793bd4cf",
  null
  
)

export default component.exports